import { defineComponent as _defineComponent } from 'vue'
import {getStore} from "@/store/getStore";
import {computed, ref, watch} from "vue";
import {DetailedCallEntityModel} from "@/services/models/entities/entities";
import {SttState} from "@/features/call2text/SttState";
import {showErrorMessage, showInfoMessage} from "@/services/ui/messages";
import apiClient from "@/services/api/apiClient";
import {StoreActionTypes} from "@/store/types";
import {renderDuration} from "../../services/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'CallSttState',
  setup(__props) {

const getSelectedCall = () => getStore().getters.getSelectedCall as unknown as DetailedCallEntityModel
const getAttachment = () => getSelectedCall().attachments[0]

const attachment = computed(() => getSelectedCall().attachments[0])
const sttState = ref<SttState | undefined>()

const sttBalance = ref(0)
const isSttBalanceLoading = ref(false)

const refreshDelay = 1000 * 30
let refreshTimeoutId: number;

async function handleEnqueue() {
  if (sttBalance.value <= 0) return

  try {
    await apiClient.entitiesApi.enqueue4stt(getSelectedCall().id)
    sttState.value = SttState.PROCESSING
    refreshTimeoutId = setTimeout(refreshCall, refreshDelay)
    showInfoMessage(`Запись поставлена в очередь на распознавание. Проверьте статус через минуту.`)
  } catch (e) {
    showErrorMessage(e)
    throw e
  }
}

function refreshCall() {
  getStore().dispatch(StoreActionTypes.SET_SELECTED_CALL, getSelectedCall().id)
}

watch(getSelectedCall, (val) => {
  sttState.value = getAttachment()?.sttState || undefined
  if (!sttState.value) {
    loadSttBalance()
  }
}, {
  immediate: true
})

async function loadSttBalance() {
  isSttBalanceLoading.value = true
  try {
    const resp = await apiClient.entitiesApi.getSttBalance()
    sttBalance.value = resp.sttBalance
  } catch (e) {
    showErrorMessage(e)
  } finally {
    isSttBalanceLoading.value = false
  }
}

return { __sfc: true,getSelectedCall, getAttachment, attachment, sttState, sttBalance, isSttBalanceLoading, refreshDelay, refreshTimeoutId, handleEnqueue, refreshCall, loadSttBalance, SttState, renderDuration }
}

})